/* OYE CULTXRE add-on sections: add to bag without leaving the page + free delivery bar */
(function () {
  if (window.__oyeLoaded) return;
  window.__oyeLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(pence) {
    var pounds = pence / 100;
    return '£' + (pounds % 1 === 0 ? pounds.toFixed(0) : pounds.toFixed(2));
  }

  function updateShippingBars(cart) {
    document.querySelectorAll('[data-oye-ship]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 7000;
      var total = cart.total_price;
      var left = Math.max(0, threshold - total);
      var text = bar.querySelector('[data-oye-ship-text]');
      var fill = bar.querySelector('[data-oye-ship-fill]');
      if (text) {
        text.textContent = left > 0
          ? (bar.getAttribute('data-msg-away') || '[amount] away from free UK delivery').replace('[amount]', money(left))
          : (bar.getAttribute('data-msg-done') || 'Free UK delivery unlocked ★');
      }
      if (fill) fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
    });
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateShippingBars(cart);
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, [data-oye-cart-count]').forEach(function (el) {
          if (/^\d*$/.test(el.textContent.trim())) el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () {});
  }

  function announce(cart) {
    // Most Shopify themes listen for one of these to refresh their cart drawer / count.
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart } }));
    });
  }

  function syncForm(form) {
    var btn = form.querySelector('[data-oye-submit]');
    if (!btn) return;
    var picked = form.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    var ready = !!(picked && picked.value);
    btn.disabled = !ready;
    if (!btn.classList.contains('is-added')) {
      btn.textContent = ready ? btn.getAttribute('data-label-ready') : btn.getAttribute('data-label-pick');
    }
    var label = form.querySelector('[data-oye-size-label]');
    if (label && picked && picked.getAttribute('data-title')) label.textContent = picked.getAttribute('data-title');
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('form[data-oye-add]');
    if (!form) return;
    var btn = form.querySelector('[data-oye-submit]');
    if (btn) { btn.classList.remove('is-added'); }
    syncForm(form);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-oye-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-oye-submit]');
    var msg = form.querySelector('[data-oye-msg]');
    var data = new FormData(form);
    if (!data.get('id')) { if (msg) msg.textContent = 'Pick a size first'; return; }
    if (btn) btn.disabled = true;
    if (msg) msg.textContent = '';

    // Impact theme (Maestrooo): ask its cart drawer which sections it needs, exactly like its own product form does.
    var impact = window.themeVariables && window.themeVariables.settings;
    if (impact) {
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      data.set('sections', sections.join(','));
      data.set('sections_url', root + 'variants/' + data.get('id'));
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to bag');
        if (form.getAttribute('data-after-add') === 'cart' || (impact && (impact.cartType === 'page' || impact.pageType === 'cart'))) {
          window.location.href = root + 'cart';
          return;
        }
        if (btn) {
          btn.classList.add('is-added');
          btn.textContent = btn.getAttribute('data-label-added') || 'Added ✓';
          btn.disabled = false;
        }
        if (impact) {
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cart.sections = res.body.sections;
              updateShippingBars(cart);
              form.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: { items: res.body.items || [res.body], cart: cart }
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cart }
              }));
            });
        }
        return refreshCart().then(announce);
      })
      .catch(function (err) {
        if (msg) msg.textContent = err.message;
        if (btn) btn.disabled = false;
      });
  });

  function init() {
    document.querySelectorAll('form[data-oye-add]').forEach(syncForm);
    if (document.querySelector('[data-oye-ship]')) refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor: re-run when a section is added or changed.
  document.addEventListener('shopify:section:load', init);
  // Keep the bar in sync if the theme's own cart changes.
  document.addEventListener('cart:updated', function (e) { if (!e.detail || !e.detail.cart) refreshCart(); });
})();
